import React, { Component } from 'react'
import '../src/assets/css/styles.css';
import '../src/input.css';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import DefaultLayout from './layout/DefaultLayout';
import { OidcProvider } from 'redux-oidc';
import store from "src/store/index"
import { userManager } from './authentication';
import { Provider, connect } from "react-redux";
import { getAdminDetails, getIpRegisteryData } from './reducers/authReducer';
import ErrorComponent from './components/shared/errorComponent';
import CardOperations from './components/cardOperations';
import CardTransactions from './components/transactions';
import ActivityLog from './components/activitylog';
import AccessDenied from './components/toolbar.component/accessDenied';
import CallbackPage from './authentication/callback.components';
import Cards from './components/cards';
import ProgramDetails from './components/programs/cardDetails';
import Programs from './components/programs';
import DeveloperConfig from './components/DeveloperConfig';
import Reports from './components/reports';
import Dashboard from './components/Dashboard';
import SumSub from './components/sumSub.component/sumsub';
import AccountStatus from './utils/accountStatus';
const NotKyc = React.lazy(() => import('./components/sumSub.component/notKyc'))
import { getkycData } from './reducers/configReduser'

import RolesGrid from './components/roles';
import RoleAddEdit from './components/roles/roleForm';
import ProfileTabs from './components/profile';
import ProfileInfo from './components/profile/personalInfo';
import UserGridData from './components/users';
import UserDetailsView from './components/users/userDetailsView';
import AddUser from './components/users/addUser';
import ChangePassword from './components/profile/changePassword';
import AuthenticatorSteps from './components/profile/authenticatorApp';
import CustomerInfo from './components/customers/customerDetails';
import CustomerTransactions from './components/customers/customerDetails/customerTransactions';
import KycDetails from './components/customers/customerDetails/Kyc/kycDetails';
import CardsDetails from './components/customers/customerDetails/cards/index';
import CardDetialsView from './components/customers/customerDetails/cards/cardDetialsView';
import Customers from './components/customers/index';
import KycInfo from './components/profile/kyb';
import ManagePermissions from './components/roles/managePermissions';
import Cases from './components/cases';
import ViewCases from './components/cases/caseView';
import Edit from './components/cases/edit';
import CreateCase from './components/customers/cases/addform';
import CardDetails from './components/cards/cardDetails';
import AuthorizationRecordsGrid from './components/cards/cardDetails/authorizationRecords';
import SettingsTabs from './components/settings'
import Operations from './components/cards/cardDetails/operations';
import Portfolio from './components/wallets'
import CasesGrid from './components/cases/cases';
import TemplateDetails from './components/cases/templates';
import Transactioninformation from './components/cards/cardDetails/transactioninformation';
import EnergyDashBoard from './components/energy';
import UserActivityLogsGrid from './components/userActivityLogs';
import KycGrid from './components/customers/customerDetails/Kyc/kycGrid';
const router = createBrowserRouter([
  {
    path: "/",
    element: <DefaultLayout />,
    errorElement: <ErrorComponent />,
    children: [
      { path: "callback", element: <CallbackPage />, errorElement: <ErrorComponent /> },
      { path: 'accessdenied', element: <AccessDenied />, errorElement: <ErrorComponent /> },
      { path: 'dashboard', element: <Dashboard />, errorElement: <ErrorComponent /> },
      { path: "wallets", element: <Portfolio />, errorElement: <ErrorComponent /> },

      { path: "operations", element: <ActivityLog />, errorElement: <ErrorComponent /> },
      {
        path: "cards", errorElement: <ErrorComponent />, element: <Cards />,
      },
      {
        path: "cards/cardDetails/:id?", element: <CardDetails />, errorElement: <ErrorComponent />, children: [
          { path: "transactions", element: <Transactioninformation />, errorElement: <ErrorComponent />, },
          { path: "authorizationRecord", element: <AuthorizationRecordsGrid />, errorElement: <ErrorComponent /> },
          { path: "operations", element: <Operations />, errorElement: <ErrorComponent /> },

        ]
      },

      { path: "cardtransactions", element: <CardTransactions />, },
      { path: "cardtransactions/:id/createcase", element: <CreateCase />, errorElement: <ErrorComponent /> },
      { path: "cardactivity", element: <CardOperations />, },


      { path: "reports", element: <Reports />, errorElement: <ErrorComponent /> },

      {
        path: "profile", element: <ProfileTabs />, errorElement: <ErrorComponent />,
        children: [
          { path: "personalInfo", element: <ProfileInfo />, errorElement: <ErrorComponent /> },
          { path: "changePassword", element: <ChangePassword />, errorElement: <ErrorComponent /> },
          { path: "authenticatorApp", element: <AuthenticatorSteps />, errorElement: <ErrorComponent /> },
          { path: "kyb", element: <KycInfo />, errorElement: <ErrorComponent /> },
        ]
      },

      { path: '/customers', element: <Customers />, errorElement: <ErrorComponent /> },
      { path: "customers/:id/createcase", element: <CreateCase />, errorElement: <ErrorComponent /> },
      {
        path: '/customer/:id', element: <CustomerInfo />, errorElement: <ErrorComponent />,
        children: [
          {
            path: "customerCards", element: <CardsDetails />, errorElement: <ErrorComponent />,
          },
          { path: "customerCards/:cardId?", element: <CardDetialsView />, errorElement: <ErrorComponent /> },
          { path: "customerTransactions", element: <CustomerTransactions />, errorElement: <ErrorComponent /> },
          { path: "customerKyc", element: <KycGrid />, errorElement: <ErrorComponent /> },
          { path: "customerKyc/details/:programId", element: <KycDetails />, errorElement: <ErrorComponent /> }
        ]
      },
      {
        path: "/cases", element: <Cases />, errorElement: <ErrorComponent />,
        children: [
          { path: "casesgrid", element: <CasesGrid />, errorElement: <ErrorComponent /> },
          { path: "templates", element: <TemplateDetails />, errorElement: <ErrorComponent /> }
        ]
      },
      { path: "/caseView/:id/:caseState", element: <ViewCases />, errorElement: <ErrorComponent /> },
      { path: "cases/edit/:id/:screen?/:caseState?", element: <Edit />, errorElement: <ErrorComponent /> },
      {
        path: "/settings", element: <SettingsTabs />, errorElement: <ErrorComponent />,
        children: [
          {
            path: "config", element: <DeveloperConfig />, errorElement: <ErrorComponent />
          },
          { path: "roles", element: <RolesGrid />, errorElement: <ErrorComponent /> },
          { path: "roles/:mode?/:id?", element: <RoleAddEdit />, errorElement: <ErrorComponent /> },
          { path: "roles/managePermissions/:id?/:roleName?", element: <ManagePermissions />, errorElement: <ErrorComponent /> },
          {
            path: "users", element: <UserGridData />, errorElement: <ErrorComponent />,
          },
          { path: 'users/:mode/:id?', element: <AddUser />, errorElement: <ErrorComponent /> },
          { path: 'users/view/:id?', element: <UserDetailsView />, errorElement: <ErrorComponent /> },
        ]
      },
      { path: '/energy', element: <EnergyDashBoard />, errorElement: <ErrorComponent /> },
      { path: "*", element: <ErrorComponent /> },
      { path: "services", element: <Programs />, errorElement: <ErrorComponent />, },
      { path: "services/cardDetails/:id?/:cardName?", element: <ProgramDetails />, errorElement: <ErrorComponent /> },
      { path: "activitylogs", element: <UserActivityLogsGrid />, errorElement: <ErrorComponent />, },
    ]
  }, { path: "sumsub", element: <SumSub />, errorElement: <ErrorComponent /> },
  { path: "notkyc", element: <NotKyc />, errorElement: <ErrorComponent /> },
  { path: "accountstatus", element: <AccountStatus />, errorElement: <ErrorComponent /> },
]);
class App extends Component {
  state = {
    isLoading: false
  }
  // async componentDidMount() {
  //   await this.getCustomerDetails()
  //   this.props.getkycDetails(this.props.user?.currentUser?.tenantId)
  // }
  //   getCustomerDetails = async () => {
  //     this.setState({isLoading:true})
  //   if (this.props.user && this.props.user.profile) {
  //     await this.props.trackauditlogs()
  //     this.props.getmemeberInformation(this.props.user.profile.sub);
  //     this.setState({ isLoading: false })
  //   }
  //   else {
  //     this.setState({ isLoading: false })
  //   }
  // }
  render() {
    return (
      <Provider store={store}>
        <OidcProvider userManager={userManager} store={store}>
          <React.StrictMode>
            {this.state.isLoading ? <div className="loader">Loading .....</div>
              : <RouterProvider router={router} />}
          </React.StrictMode>
        </OidcProvider>
      </Provider>
    )
  }
}
const connectStateToProps = ({ userConfig, oidc }) => {
  return { userConfig: userConfig?.userProfileInfo, user: oidc?.user }
}
const connectDispatchToProps = dispatch => {
  return {
    getmemeberInformation: (useremail) => {
      dispatch(getAdminDetails(useremail));
    },
    trackauditlogs: () => {
      dispatch(getIpRegisteryData());
    },
    getkycDetails: (tenantId) => {
      dispatch(getkycData(tenantId))
    }
  }
}
export default connect(connectStateToProps, connectDispatchToProps)(App);